import { getRawMessage } from 'locale'
import { isInternationalVersion } from 'settings/locale.settings'

const nationBasedFields = isInternationalVersion()
  ? [
      {
        name: 'field_verify_email_success_message',
        value: getRawMessage(
          'pages.formMaker.section.formSettings.generalFields.custom.text.verifyEmailSuccess'
        ),
        label: getRawMessage(
          'pages.formMaker.section.formSettings.generalFields.custom.text.verifyEmailSuccess.label'
        ),
      },
      {
        name: 'field_verify_email_fail_message',
        value: getRawMessage(
          'pages.formMaker.section.formSettings.generalFields.custom.text.verifyEmailFail'
        ),
        label: getRawMessage(
          'pages.formMaker.section.formSettings.generalFields.custom.text.verifyEmailFail.label'
        ),
      },
    ]
  : [
      {
        name: 'field_verify_success_message',
        value: getRawMessage(
          'pages.formMaker.section.formSettings.generalFields.custom.text.verifySuccess'
        ),
        label: getRawMessage(
          'pages.formMaker.section.formSettings.generalFields.custom.text.verifySuccess.label'
        ),
      },

      {
        name: 'field_verify_fail_message',
        value: getRawMessage(
          'pages.formMaker.section.formSettings.generalFields.custom.text.verifyPhoneFail'
        ),
        label: getRawMessage(
          'pages.formMaker.section.formSettings.generalFields.custom.text.verifyPhoneFail.label'
        ),
      },
    ]

export const customTextFields = [
  {
    name: 'continue_btn',
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.btn.continue.label'
    ),
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.btn.continue'
    ),
  },
  {
    name: 'start_btn',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.btn.start'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.btn.start.label'
    ),
  },
  {
    name: 'next_btn',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.btn.next'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.btn.next.label'
    ),
  },
  {
    name: 'previous_btn',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.btn.prev'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.btn.prev.label'
    ),
  },
  {
    name: 'view_answer_sheet_btn',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.btn.answerSheet'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.btn.answerSheet.label'
    ),
  },
  {
    name: 'total_score_label',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.label.totalScore'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.label.totalScore.label'
    ),
  },
  {
    name: 'total_price_label',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.label.totalPrice'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.label.totalPrice.label'
    ),
  },
  {
    name: 'progress_bar_label',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.progressBar'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.progressBar.label'
    ),
  },
  {
    name: 'start_label',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.label.start'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.label.start.label'
    ),
  },
  {
    name: 'other_choice_label',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.choice.other'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.choice.other.label'
    ),
  },
  {
    name: 'table_question_label',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.table.question'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.table.question.label'
    ),
  },
  {
    name: 'long_text_hint',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.longText.hint'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.longText.hint.label'
    ),
  },

  {
    name: 'field_required_message',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.required'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.required.label'
    ),
  },
  {
    name: 'field_matrix_required_message',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.required.matrix'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.required.matrix.label'
    ),
  },
  {
    name: 'field_maxLength_message',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.maxLength'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.maxLength.label'
    ),
  },
  {
    name: 'field_minValue_message',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.minValue'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.minValue.label'
    ),
  },
  {
    name: 'field_maxValue_message',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.maxValue'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.maxValue.label'
    ),
  },
  {
    name: 'field_maxDigit_message',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.maxDigit'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.maxDigit.label'
    ),
  },
  {
    name: 'field_email_message',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.email'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.email.label'
    ),
  },
  {
    name: 'field_url_message',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.url'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.url.label'
    ),
  },
  {
    name: 'field_acceptable_minItem_message',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.acceptable.minItem'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.acceptable.minItem.label'
    ),
  },
  {
    name: 'field_acceptable_maxItem_message',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.acceptable.maxItem'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.acceptable.maxItem.label'
    ),
  },
  {
    name: 'field_product_max_message',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.product.max'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.product.max.label'
    ),
  },
  {
    name: 'field_product_min_message',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.product.min'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.product.min.label'
    ),
  },
  {
    name: 'field_regex_message',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.regex'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.regex.label'
    ),
  },
  {
    name: 'field_phone_message',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.phone'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.phone.label'
    ),
  },
  {
    name: 'field_time_range_message',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.time.range'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.time.range.label'
    ),
  },
  {
    name: 'field_time_from_message',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.time.from'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.time.from.label'
    ),
  },
  {
    name: 'field_time_to_message',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.time.to'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.time.to.label'
    ),
  },
  {
    name: 'field_select_placeholder',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.select.placeholder'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.select.placeholder.label'
    ),
  },
  {
    name: 'field_product_quantity',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.product.quantity'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.product.quantity.label'
    ),
  },
  {
    name: 'field_file_placeholder',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.file.placeholder'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.file.placeholder.label'
    ),
  },
  {
    name: 'field_file_size_limit',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.fileSize'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.fileSize.label'
    ),
  },
  {
    name: 'field_file_maxCount',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.file.maxUpload'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.file.maxUpload.label'
    ),
  },
  {
    name: 'field_file_minCount',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.file.minUpload'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.file.minUpload.label'
    ),
  },
  {
    name: 'field_decimal_place',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.decimal'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.decimal.label'
    ),
  },
  {
    name: 'field_verify_button',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.verifyButton'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.verifyButton.label'
    ),
  },
  {
    name: 'field_verify_resend_message',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.resendButton'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.resendButton.label'
    ),
  },
  {
    name: 'field_verify_confirmed_message',
    value: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.confirmMessage'
    ),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.confirmMessage.label'
    ),
  },
  {
    name: 'field_signature_clear_button',
    value: getRawMessage('general.clear'),
    label: getRawMessage(
      'pages.formMaker.section.formSettings.generalFields.custom.text.clearButton.label'
    ),
  },
  ...nationBasedFields,
]
